import { render, staticRenderFns } from "./Overzicht.vue?vue&type=template&id=08dca56c&"
import script from "./Overzicht.vue?vue&type=script&lang=js&"
export * from "./Overzicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports